const staleChunkReloadKey = "wms:stale-chunk-reloaded"
const staleChunkErrorPatterns = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "error loading dynamically imported module",
]

// Identifies browser errors emitted when a previously cached bundle points to a removed Vite chunk.
function isStaleChunkError(value: unknown) {
  const message =
    value instanceof Error
      ? value.message
      : typeof value === "string"
        ? value
        : ""

  return staleChunkErrorPatterns.some((pattern) => message.includes(pattern))
}

// Reloads the current page once so the browser can fetch the current index and chunk graph.
function reloadOnceForFreshAssets() {
  if (sessionStorage.getItem(staleChunkReloadKey) === "1") return

  sessionStorage.setItem(staleChunkReloadKey, "1")
  window.location.reload()
}

// Installs global handlers that recover from stale dynamic-import chunks after a deployment.
export function installStaleChunkReloadHandler() {
  window.addEventListener("error", (event) => {
    if (isStaleChunkError(event.error) || isStaleChunkError(event.message)) {
      reloadOnceForFreshAssets()
    }
  })

  window.addEventListener("unhandledrejection", (event) => {
    if (isStaleChunkError(event.reason)) {
      reloadOnceForFreshAssets()
    }
  })

  window.addEventListener("load", () => {
    sessionStorage.removeItem(staleChunkReloadKey)
  })
}
